import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * デバイス情報をAPIを使用して更新する関数。
 *
 * @param {string} apiToken - APIアクセス用のトークン。
 * @param {Object} apiParams - APIリクエストのためのパラメータ。
 * @returns {Function} Redux dispatch関数
 */
const updateDevice = (apiToken, apiParams) => dispatch => {
  consolelog('[API CALL] updateDevice()', apiParams);
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_UPDATE_DEVICE;
  const { cancelToken, cancelTokenKey } = createCancelToken('updateDevice');
  const params = {
    cancelToken,
    ...apiParams,
  };
  return axios
    .post(url, params)
    .then(res => {
      delCancelToken(cancelTokenKey);
      dispatch({
        type: actionTypes.SUCCESS_API_UPDATE_DEVICE,
        payload: res.data,
      });
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
    });
};

export default updateDevice;
